"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDeliveryPickedUp = void 0;
const delivery_1 = require("../features/base/ordering/types/delivery");
const isDeliveryPickedUp = (status) => {
    const statuses = Object.values(delivery_1.DeliveryPartnerStatus);
    const pickedUpIndex = statuses.indexOf(delivery_1.DeliveryPartnerStatus.PickedUp);
    if (pickedUpIndex === -1) {
        // PickedUp status not found in the enum
        return false;
    }
    const currentIndex = statuses.indexOf(status);
    return currentIndex >= pickedUpIndex;
};
exports.isDeliveryPickedUp = isDeliveryPickedUp;
//# sourceMappingURL=isDeliveryPickedUp.js.map